module.exports = "<mdl-spinner single-color active class='spinner'></mdl-spinner>";